import { render } from "./SectionOverTime.vue?vue&type=template&id=45bc4ffd&scoped=true"
import script from "./SectionOverTime.vue?vue&type=script&lang=js"
export * from "./SectionOverTime.vue?vue&type=script&lang=js"

import "./SectionOverTime.vue?vue&type=style&index=0&id=45bc4ffd&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bc4ffd"]])

export default __exports__